<template>
  <div id="OAEmailValidation">
    <div class="role">
      OA
    </div>
    <EmailValidationForm
      class="card"
      :dialog-width="dialogWidth"
    />
  </div>
</template>

<script>
import DialogSetting from '@/mixins/dialog';
import EmailValidationForm from './EmailValidationForm.vue';

export default {
  components: {
    EmailValidationForm,
  },

  mixins: [DialogSetting],
};
</script>

<style lang="scss" scoped>
#OAEmailValidation {
  min-height: 100vh;
  background-color: #aab1cc;
  padding: 0 5px 20px;
  box-sizing: border-box;

  .role {
    font-size: 22px;
    font-weight: bold;
    padding: 20px;
  }

  .card {
    display: inline-block;
  }
}
</style>
